module.exports = __webpack_public_path__ + "static/media/LoginHero.b0c53437.png";